var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mb-4",attrs:{"outlined":"","ripple":false,"loading":_vm.loading}},[_c('v-card-title',[_vm._v("Message")]),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.contact.ctcMessage)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }